import store from "@/store/index.js";
import { createProvider } from "@/vue-apollo.js";
const apolloClients = createProvider().defaultClient;

/**
 * apollo client query common fn
 * @param query  query documentNode
 * @param variables [obj] any type variable
 * @returns success -> data fail-> err
 * @author 송은석 2022-04-06
 */
export async function runGqlQuery(query, variables) {
  try {
    await store.commit("common/changeIsLoading", { isLoading: true });

    const { data } = await apolloClients.query({
      query,
      variables,
      fetchPolicy: "no-cache",
    });

    await store.commit("common/changeIsLoading", { isLoading: false });
    return data;
  } catch (e) {
    await store.commit("common/changeIsLoading", { isLoading: false });
    await store.commit("common/error", { errorMessage: e.message });
    return e;
  }
}

/**
 * apollo client mutation common fn
 * @param mutate  mutate documentNode
 * @param variables [obj] any type variable
 * @returns success -> data fail-> err
 * @author 송은석 2022-04-06
 */
export async function runGqlMutation(mutation, variables) {
  try {
    await store.commit("common/changeIsLoading", { isLoading: true });

    const { data } = await apolloClients.mutate({
      mutation,
      variables,
      fetchPolicy: "no-cache",
    });

    await store.commit("common/changeIsLoading", { isLoading: false });
    return data;
  } catch (e) {
    await store.commit("common/changeIsLoading", { isLoading: false });
    await store.commit("common/error", { errorMessage: e.message });
    return e;
  }
}
